/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DiagnosisCertaintyEnum = {
    Confirmed: 'CONFIRMED',
    Suspected: 'SUSPECTED',
    Excluded: 'EXCLUDED',
    StatusPost: 'STATUS_POST'
} as const;
export type DiagnosisCertaintyEnum = typeof DiagnosisCertaintyEnum[keyof typeof DiagnosisCertaintyEnum];

